
import axios from 'axios';

const API_BASE_URL = 'https://api.github.com';

export const getUserData = async (username) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${username}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const getUserRepos = async (username) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/users/${username}/repos?per_page=100&sort=updated`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user repos:', error);
    throw error;
  }
};
